import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const breadcrumbsStatic = [{
	name: 'Idle Tasks',
	url: '/dispatch/idle_tasks',
	icon: 'users',
}];

class DispatchIdleTasks extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	refreshPage = () => {
		this.setState({
			key: Math.random(),
			refresh: !this.state.refresh
		});
	};

	render() {
		let {history} = this.props;

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button onClick={async () => {
						await this.refreshPage();
					}} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Refresh Data
					</Button>
				</Framework.Components.PageBar>


				<Collections.IdleTasks
					key={this.state.key}
					history={history}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					filter={"Dispatch"}
					user={this.props.rootState.user}
					isAtLeastManager={false}
					all_roles={[30]}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(DispatchIdleTasks)

